<div *ngIf="loading" class="app-loader">
  <div class="h-full flex align-items-center justify-content-center">
    <div class="lds-ripple"><div></div><div></div></div>
    <div *ngIf="loadingPercent>0">
      <div style="margin-top: -20px;"><h3>{{loadingPercent}}%</h3></div>
    </div>
  </div>
</div>
